require('./cardDepositMoneyView.scss');
const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @constants
const { FIRST_STEP } = require('constants/index');

// @actions
const cardDepositMoneyActions = require('actions/cardDepositMoney');
const cardsPaymentCycleActions = require('actions/cardsPaymentCycle');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { DepositMoneyStep1 } = require('components/cards/cardDepositMoneySteps/depositMoneyStep1/depositMoneyStep1');
const DepositMoneyStep2 = require('components/cards/cardDepositMoneySteps/depositMoneyStep2/depositMoneyStep2');
const DepositMoneyFinalStep = require('components/cards/cardDepositMoneySteps/depositMoneyFinalStep/depositMoneyFinalStep');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const WebappRender = require('components/conditionalRender/webappRender')
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');

// @utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');
const { contactCenterClassName, conditionalClassName } = require('utilities/conditionals/conditionalClassname')
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

// @constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');

class CardDepositMoneyView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);

        const { history, immCards, match: { params: { cardId } } } = props;
        const immCard = immCards.getIn(['byId', cardId]);

        const allowAccess = AccessHelper.allowAccess(cardConstants.CARD_DEPOSIT_MONEY, { immCard }, history);

        this.state = {
            allowAccess,
        };
    }

    componentDidMount() {
        const { immCards, match: { params: { cardId } }, setCreditCardData, immAccounts, setAllAccountsToInactive, getCardsPaymentCycle } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const totalContractBalanceDrawnAmount = immCard.getIn(['totalContractBalanceDrawn', 'amount']);
        const creditCardLimit = immCard.getIn(["limit", "amount"]);
        getCardsPaymentCycle(immCard);
        setCreditCardData(totalContractBalanceDrawnAmount, creditCardLimit);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/ingreso-dinero', PAGE_GENERIC, '', '', tagging);

        const allAccountsInactive = hasAllAccountsInactive(this.sortAccounts(immAccounts.get('byOrder'), immAccounts.get('byId')), immAccounts.get('byId'));
        if (allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    buildSuccessful(immCard) {
        const { immCardDepositMoney } = this.props;
        const immSteps = immCardDepositMoney.get('steps');

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <DepositMoneyFinalStep
                    error={immCardDepositMoney.get('error')}
                    errorState={immCardDepositMoney.get('submitError')}
                    immCard={immCard} immStep={immSteps.get(FIRST_STEP)}
                />
            </div>
        )
    }

    buildWizard(immCard) {
        const {
            immAccounts,
            immCardDepositMoney,
            immCardsPaymentCycle,
            immFlagBasedFeatures,
            setAllAccountsToInactive,
            setVisibleStep,
            setWillCancel,
            validateStep
        } = this.props;
        const accountsList = immAccounts.get('byOrder');
        const accountsMap = immAccounts.get('byId');
        const immSteps = immCardDepositMoney.get('steps');
        const actions = {
            validateStep,
            setAllAccountsToInactive,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };
        let accountsIndexes = [];

        if (accountsList.size > 0) {
            accountsIndexes = this.sortAccounts(accountsList, accountsMap);
        }

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immCardDepositMoney.get('visibleStep')}
                showPreLeaveModal={this.state.allowAccess}>
                <WizardStep position="first" cancelButton={true} >
                    <DepositMoneyStep1
                        accountsIndexes={accountsIndexes}
                        cardsPaymentCycleEnabled={immFlagBasedFeatures.get('web-card-closing-date-disclaimer-enabled')}
                        immAccounts={accountsMap}
                        immCard={immCard}
                        immCardsPaymentCycle={immCardsPaymentCycle}
                        immStep={immSteps.get(FIRST_STEP)}
                        isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                        setAllAccountsToInactive={setAllAccountsToInactive}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton="cardDepositMoney-depositMoney"
                    addLoadingBehaviour={true}>
                    <DepositMoneyStep2 immCard={immCard} immCardDepositMoney={immCardDepositMoney.get('steps').get(0)} />
                </WizardStep>
            </Wizard>
        )
    }

    handleCancel() {
        const { cardId } = this.props.match.params;

        this.props.history.push(`/myprofile/cards/${cardId}/details`);
    }

    handleFinish() {
        const { match: { params: { cardId } }, immCards, immCardDepositMoney } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        this.props.handleFinish(immCard.get('cardId'), immCardDepositMoney.get('steps').get(0).get('fromAccount'));
    }

    sortAccounts(accountsList, accountsMap) {
        let positiveIndexes = [];

        accountsList.forEach(accountId => {
            const amount = accountsMap.getIn([accountId, 'balances', 'availableBalance', 'amount']);
            const accountProduct = accountsMap.getIn([accountId, 'newProduct']);
            if (amount > 0 && accountProduct === '300' /*CUENTA CORRIENTE*/) {
                positiveIndexes.push(accountId)
            }
        });

        return positiveIndexes;
    }

    render() {
        const { match: { params: { cardId } }, immCards, immCardDepositMoney } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-cardsDepositMoneyTitle')}
            />
        );
        let content = (<div></div>);

        if (immCards.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immCard) {
            const titleKey = immCard.get('isViaT') ? 'cardDepositMoney-depositMoneyToTheCardViaT' : 'cardDepositMoney-depositMoneyToTheCard';
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('cardDetails-depositMoney')
                }
            ];
            let bodyContent;

            if (immCardDepositMoney.get('submitSuccessful') || immCardDepositMoney.get('submitError')) {
                bodyContent = this.buildSuccessful(immCard);
            } else if (immCardDepositMoney.get('allAccountsInactive')) {
                bodyContent = (
                    <div className="col-xs-12 col-md-offset-1 col-md-10">
                        <InactiveAccountsError
                            navigateToBackButtonText={'cards'}
                            navigateToBackButtonURL={'cards'}
                        />
                    </div>
                );
            } else {
                const wizard = this.buildWizard(immCard);
                const depositMoneySidebarClassName = conditionalClassName('hidden-md', 'card-deposit-money__sidebar col-md-4', 'hidden-xs hidden-sm col-lg-4')
                bodyContent = (
                    <div>
                        {/* >> CONTENT DUPLICATED: REF-01 */}
                        <WebappRender>
                            <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                                <CardDetailsSidebar immCard={immCard} />
                            </div>
                        </WebappRender>
                        {/* CONTENT DUPLICATED: REF-01 << */}
                        <div className="col-md-12-cc-8 col-lg-8-cc-8" id="printable-wizard">
                            {wizard}
                        </div>
                        {/* >> REF-01 */}
                        <div className={depositMoneySidebarClassName}>
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                        {/* REF-01 << */}
                    </div>
                );
            }

            const depositMoneyBodyClassName = contactCenterClassName('card-deposit-money__body', 'grid-view__body')
            const depositMoneyContainerClassName = contactCenterClassName('card-deposit-money__container', 'container-fluid')
            content = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    tutorial={tutorial}
                                    finalTitle={getFinalTitle(titleKey)}>
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className={depositMoneyBodyClassName}>
                        <div className={depositMoneyContainerClassName}>
                            <div className="row grid-view--content-position-negative">
                                {bodyContent}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }
}

CardDepositMoneyView.propTypes = {
    clearRequest: PropTypes.func.isRequired,
    getCardsPaymentCycle: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCardDepositMoney: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardsPaymentCycle: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setCreditCardData: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports.constructor = CardDepositMoneyView;
module.exports.CardDepositMoneyView = connect(
    state => ({
        immAccounts: state.accounts,
        immCardDepositMoney: state.cardDepositMoney,
        immCards: state.cards,
        immCardsPaymentCycle: state.cardsPaymentCycle,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), {
    clearRequest: cardDepositMoneyActions.clearRequest,
    getCardsPaymentCycle: cardsPaymentCycleActions.getCardsPaymentCycle,
    handleFinish: cardDepositMoneyActions.postDeposit,
    setAllAccountsToInactive: cardDepositMoneyActions.setAllAccountsToInactive,
    setCreditCardData: cardDepositMoneyActions.setCreditCardData,
    setVisibleStep: cardDepositMoneyActions.setVisibleStep,
    setWillCancel: cardDepositMoneyActions.setWillCancel,
    validateStep: cardDepositMoneyActions.validateStep,
})(withRouter(CardDepositMoneyView));
